import { Component, OnInit } from '@angular/core';
import { PublicService } from 'src/app/servicios/public/public.service';

declare var $:any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  public novedades: any = [];

  constructor(private servi: PublicService) {
    this.servi.GetIndexNovedades()
      .subscribe(data => { this.novedades = data; });
   }

  ngOnInit() 
  {
    $("#tutorialModal").modal("show");
    this.ensureVideoPlays();

    $('#tutorialModal').on('hidden.bs.modal', function () {
      $('video').trigger('pause');
    });
  }

  private ensureVideoPlays(): void{
    const video = document.querySelector("video");

    if(!video) return;
    
    const promise = video.play();
    if(promise !== undefined){
        promise.then(() => {
            // Autoplay started
        }).catch(error => {
            // Autoplay was prevented.
            video.muted = true;
            video.play();
        });
    }
}

}
